// Real Lilah C. Photography imagery. Swap HERO_IMG / STORY_IMG when the portrait
// and behind-the-lens shots arrive.
const FLORALS = "https://customer-assets-lqy194kg.emergentagent.net/job_lilah-photo-studio/artifacts/h64qljr1_IMG_3584-2.webp";
const BRIDESMAIDS = "https://customer-assets-lqy194kg.emergentagent.net/job_lilah-photo-studio/artifacts/2wraxnr2_IMG_3648-2%20%281%29.webp";
const DJ_HAND = "https://customer-assets-lqy194kg.emergentagent.net/job_lilah-photo-studio/artifacts/aomnrx4e_IMG_5693-2.webp";
const DJ_DECK = "https://customer-assets-lqy194kg.emergentagent.net/job_lilah-photo-studio/artifacts/mavd0d5s_IMG_5703-2-2%20%281%29.webp";
const LILAH = "https://customer-assets-lqy194kg.emergentagent.net/job_lilah-photo-studio/artifacts/qh7a1mzf_IMG_8734.webp";

export const HERO_IMG = BRIDESMAIDS;
export const STORY_IMG = LILAH;
export const BOOKING_IMG = FLORALS;

export const CATEGORIES = ["All", "Weddings", "DJ"];

export const GALLERY = [
  { id: 1, cat: "Weddings", title: "Petals & Candlelight", place: "Miami", ratio: "tall", url: FLORALS },
  { id: 2, cat: "Weddings", title: "The Wedding Party", place: "Coral Gables", ratio: "wide", url: BRIDESMAIDS },
  { id: 4, cat: "DJ", title: "Behind the Decks", place: "Miami", ratio: "wide", url: DJ_HAND },
  { id: 5, cat: "DJ", title: "On the Ones & Twos", place: "Miami", ratio: "wide", url: DJ_DECK },
];

export const CHAPTERS = [
  { no: "01", title: "The Spark", body: "From a young age I was captivated by my father's camera — fascinated by the quiet ritual of capturing a moment and shaping it in the edit. That fascination never left." },
  { no: "02", title: "The Story", body: "A picture is worth a thousand words. Every frame I make is built to carry a story — one that resonates long after the shutter closes." },
  { no: "03", title: "The Promise", body: "My style is focused on your goals. I listen first, then I deliver exactly what you need — nothing generic, everything intentional." },
];

export const SERVICES = [
  "Event Photography", "Family Portraits", "Brand & Lifestyle", "Pet Photography",
  "Sports Photography", "Real Estate", "Corporate Coverage", "Editorial & Creative",
];

export const LOGO_IMG = "https://customer-assets-lqy194kg.emergentagent.net/job_lilah-photo-studio/artifacts/05ncaf2t_Lilah%27s%20Logo%20%281%29.png";
export const QR_IMG = "https://customer-assets-lqy194kg.emergentagent.net/job_lilah-photo-studio/artifacts/44avti1o_lilahcphotography_qr.webp";
export const INSTAGRAM_URL = "https://instagram.com/lilahcphotography";
